<template>
  <Popup id="confirm-container" :value="value" popupHeader="Close this job?" @input="$emit('input', $event)">
    <p class="text-body mb-16">Once you close this job, new sitters will no longer be able to apply for it</p>
    <Button id="close-job-confirm" value="Close job" size="medium" class="w-full" @click="$emit('confirm')" />
  </Popup>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Button from '@/components/button/Button.vue';
import Popup from '@/components/popup/Popup.vue';

export default defineComponent({
  name: 'JobCloseConfirmation',
  components: {
    Button,
    Popup,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['input', 'confirm'],
});
</script>
